import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { CaptureContext, SeverityLevel } from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class ErrorReportingService {
  captureException(error: unknown, captureContext?: CaptureContext): void {
    Sentry.captureException(error, captureContext);
  }

  captureMessage(
    message: string,
    captureContext?: CaptureContext | SeverityLevel,
  ): void {
    Sentry.captureMessage(message, captureContext);
  }
}
